module.exports = __webpack_public_path__ + "media/site_templates/www.cheapgardenservices.com.au/images/our_services_3-3d70bc7472f72e54b17ec4b74a6b6697.jpg";